module.exports = __webpack_public_path__ + "static/media/skill6_neg_es.f7b72630.txt";